import { useMutation, useQueryClient } from '@tanstack/react-query';
import { PRODUCTS_STATUS_QUERY_KEY } from '@/apiHooks/queryKeys';
import { startTenantProtection, validateToken } from '../api/tenantProtection/getTenantProtection';

export const useStartTenantProtection = () => {
  const queryClient = useQueryClient();
  const { mutateAsync, isSuccess } = useMutation(startTenantProtection, {
    onSuccess: () => queryClient.invalidateQueries(PRODUCTS_STATUS_QUERY_KEY),
    onError: () => queryClient.invalidateQueries(PRODUCTS_STATUS_QUERY_KEY),
  });

  return {
    isSuccess,
    mutate: mutateAsync,
  };
};

export const useValidateTenantProtection = () => {
  const { mutateAsync, isSuccess, isLoading, isError } = useMutation(async ({ token }: { token: string }) => {
    const data = await validateToken(token);
    return data;
  });

  return {
    isLoading,
    isError,
    isSuccess,
    mutate: mutateAsync,
  };
};
